// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-29T17:44:03.216Z
// Property: The Meyden (ID: 6767906449164266)
// Collections: 50 amenities, 44 floorplans (live), 9 photos, 30 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162415",
  "multihub_property_id": "6767906449164266",
  "property_external_id": "464900",
  "property_zillow_url": "https://www.zillow.com/apartments/bellevue-wa/the-meyden/5hJ4p9/",
  "property_apartments_url": "https://www.apartments.com/10333-main-st-bellevue-wa/8fkt092/",
  "property_google_business_url": "https://www.google.com/maps?cid=12474728225764714145",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-meyden",
  "property_name": "The Meyden",
  "property_website_url": "https://www.themeydenbellevue.com",
  "property_domain": "https://www.themeydenbellevue.com",
  "property_address": "10333 Main Street",
  "property_full_address": "10333 Main St, Bellevue, WA 98004",
  "property_address_1": "10333 Main Street",
  "property_address_2": null,
  "property_address_city": "Bellevue",
  "property_address_state": "WA",
  "property_address_zip_full": null,
  "property_address_zip": "98004",
  "property_address_country": "US",
  "property_address_county": "King County",
  "property_neighborhood_address": "West Bellevue",
  "property_address_latitude": "47.6098996",
  "property_address_longitude": "-122.2024382",
  "property_email": "info@themeydenbellevue.com",
  "property_phone": "(844) 275-9825",
  "property_call_tracking_phone": "844-329-2216",
  "property_company_name": "Pillar Properties",
  "property_company_url": "https://www.pillarproperties.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to The Meyden in Bellevue, WA, where modern living meets extraordinary amenities. Enjoy our vibrant sports lounge, unwind in the high-tech theater, or relax by the cozy fire pits. Choose from spacious studio, one, or two-bedroom floor plans designed for your lifestyle. Find your new home today!",
  "property_long_description": "Live, work, laugh and play in downtown Bellevue Main StreetLocated at the corner of Bellevue Way and Main Street, The Meyden in the heart of Bellevue with shopping, entertainment, and parks just outside your door.Perfectly matched to your lifestyle.Discover our spacious apartment homes, designed for entertaining, enjoy the resident lounges and courtyards with fireside seating, water fountains, outdoor gourmet grilling stations, sun chaise lounges, tables for friends amongst beautiful landscaping,  media lounge, sports lounge reservable for special events. Come see our state of the art 24-hour fitness gym. View our rentable guest suite and our custom Theater.The Meyden is designed to exceed expectations.Your new home features individually controlled air conditioning and heating, solid quartz countertops, large kitchens with stainless steel appliances, custom cabinetry with slow to close cabinet doors and drawers, flooring in our homes is tile and wood throughout the living/ dining/ kitchen.  Berber carpeting in the bedrooms, full size washer and dryer, 9 foot ceilings, large beautiful viewing windows to accentuate our City Views and Tree views.The Meyden is a like a walk in the park, fresh, crisp, inspiring, pleasant, enjoyable, in your home you will relax, renew, create, settle in and Live within all the things to do and partake on Main Street!Come see us today!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019db4fb-97c1-747c-9c01-496cfa94f4f9.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of The Meyden apartment building with ground-floor retail spaces and balconies.",
    "public_id": "019db4fb-97c1-747c-9c01-496cfa94f4f9",
    "storage_key": "property/6767906449164266/019db4fb-97c1-747c-9c01-496cfa94f4f9.webp",
    "width": 1900,
    "height": 994
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "254",
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.7007874015748",
  "property_admin_fee": "300",
  "property_application_fee": "50",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "180",
  "property_pet_restrictions": "Restrictions - Poisonous Animals to include Tarantulas and Piranhas.  Exotic Animals to include reptiles (snakes, iguanas), ferrets, skunks, racoons, squirrels, rabbits, and birds (parrots, cockatiels, macaws)",
  "property_pet_policy_description": "Pet Types Allowed: Dogs and Cats\nMax Pets: 2\nMonthly Pet Rent: $50/ Month per pet\nPet rent applies per pet\nPet Deposit: $300\nNon-Refundable One-Time Pet Fee: $300",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://themeydenbellevue.securecafe.com/onlineleasing/the-meyden/floorplans.aspx",
  "property_resident_portal_url": "https://themeydenbellevue.securecafenet.com/residentservices/the-meyden/userlogin",
  "property_apply_now_url": "https://themeydenbellevue.securecafe.com/onlineleasing/the-meyden/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f663-7208-9181-23c451f33a13.webp",
  "property_primary_logo_media": {
    "alt_text": "The Meyden logo",
    "public_id": "019d0812-f663-7208-9181-23c451f33a13",
    "storage_key": "property/6767906449164266/019d0812-f663-7208-9181-23c451f33a13.webp",
    "width": 350,
    "height": 203
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f663-7208-9181-23c451f33a13.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Meyden logo",
    "public_id": "019d0812-f663-7208-9181-23c451f33a13",
    "storage_key": "property/6767906449164266/019d0812-f663-7208-9181-23c451f33a13.webp",
    "width": 350,
    "height": 203
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0814-6629-76b9-9be3-bf491fd22cde.webp",
  "property_icon_media": {
    "alt_text": "M emblem logo",
    "public_id": "019d0814-6629-76b9-9be3-bf491fd22cde",
    "storage_key": "property/6767906449164266/019d0814-6629-76b9-9be3-bf491fd22cde.webp",
    "width": 144,
    "height": 144
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0814-6629-76b9-9be3-bf491fd22cde.webp",
  "property_fav_icon_media": {
    "alt_text": "M emblem logo",
    "public_id": "019d0814-6629-76b9-9be3-bf491fd22cde",
    "storage_key": "property/6767906449164266/019d0814-6629-76b9-9be3-bf491fd22cde.webp",
    "width": 144,
    "height": 144
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-6137-769d-85f4-4440f13f982c.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Meyden logo: stylized M inside a diamond shape with surrounding geometric elements.",
    "public_id": "019d0812-6137-769d-85f4-4440f13f982c",
    "storage_key": "property/6767906449164266/019d0812-6137-769d-85f4-4440f13f982c.webp",
    "width": 528,
    "height": 307
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019db4fa-2e09-7669-8e1f-b514f75df562.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Meyden logo",
    "public_id": "019db4fa-2e09-7669-8e1f-b514f75df562",
    "storage_key": "property/6767906449164266/019db4fa-2e09-7669-8e1f-b514f75df562.webp",
    "width": 1094,
    "height": 635
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d06cf-26f9-7551-948c-1245b11c8422.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d2fc2-1eb8-7554-8d89-d3424651cf63.webp",
  "property_company_logo_media": {
    "alt_text": "Pillar Properties logo",
    "public_id": "019d2fc2-1eb8-7554-8d89-d3424651cf63",
    "storage_key": "company/5767906449162415/019d2fc2-1eb8-7554-8d89-d3424651cf63.webp",
    "width": 189,
    "height": 128
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d2fc1-9029-7028-b531-c3ae9dacde22.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Pillar Properties logo",
    "public_id": "019d2fc1-9029-7028-b531-c3ae9dacde22",
    "storage_key": "company/5767906449162415/019d2fc1-9029-7028-b531-c3ae9dacde22.webp",
    "width": 178,
    "height": 122
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d2fc1-00d2-7093-a184-b3de0f0bba5a.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Pillar Properties logo",
    "public_id": "019d2fc1-00d2-7093-a184-b3de0f0bba5a",
    "storage_key": "company/5767906449162415/019d2fc1-00d2-7093-a184-b3de0f0bba5a.webp",
    "width": 178,
    "height": 122
  },
  "property_primary_color": "#008abb",
  "property_secondary_color": "#969497",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "448 - 1379",
  "property_sqft_min": "448",
  "property_sqft_max": "1379",
  "property_price_range": "1856 - 5333",
  "property_price_min": "1856",
  "property_price_max": "5333",
  "property_available_units": 25,
  "property_facebook_url": "https://www.facebook.com/TheMeydenBellevue",
  "property_instagram_url": "https://www.instagram.com/themeydenbell",
  "property_twitter_url": "https://x.com/TheMeydenBell",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJFYpw5X1skFQRoaY-NjojH60",
  "property_youtube_url": "https://www.youtube.com/watch?v=JlhFeHK6PFM",
  "property_yelp_url": "https://www.yelp.com/biz/venn-at-main-apartments-bellevue-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Meyden",
  "property_home_romance_title": "Welcome to The Meyden",
  "property_home_amenities_blurb": "Welcome to The Meyden in Bellevue, WA, where modern living meets vibrant community spirit. Enjoy spacious floor plans—from cozy studios to versatile two-bedroom apartments—paired with top-notch amenities like our tech-savvy theater, sports lounge, and tranquil outdoor spaces. Embrace comfort and style in every corner of your new home!",
  "property_home_floorplans_blurb": "Welcome to The Meyden in Bellevue, WA, where your ideal living space awaits! From cozy studios to spacious two-bedroom apartments, our thoughtfully designed floor plans cater to every lifestyle. Browse our available options and elevate your living experience in a vibrant community that feels like home.",
  "property_home_gallery_blurb": "Experience the vibrant lifestyle at The Meyden in Bellevue, WA, where modern luxury meets community charm. Elevate your days with our premier amenities, from a high-tech theater to a cozy sports lounge. Picture yourself unwinding on spacious balconies or socializing around fire pits in our courtyard. Welcome home! ",
  "property_home_neighborhood_blurb": "At The Meyden in vibrant Bellevue, WA, your ideal lifestyle awaits. Choose from spacious studios to inviting two-bedrooms, right near local gems like Bellevue College and the Burke Museum. Discover the enriching parks and dynamic spaces that make our neighborhood truly exceptional. Experience a community that inspires exploration!",
  "property_home_reviews_blurb": "At The Meyden in Bellevue, residents thrive in a vibrant community where every detail matters. As one happy tenant shares, “It feels like home,” thanks to our friendly staff, responsive maintenance team, and engaging monthly events. Experience exceptional living with top-notch amenities and a welcoming atmosphere. You belong here!",
  "property_neighborhood_blurb": "Nestled in the heart of Bellevue, The Meyden offers convenient access to cultural treasures and vibrant experiences. From the awe-inspiring Burke Museum to serene Marymoor Park, adventure awaits just moments away. Embrace an active lifestyle with easy access to top-tier fitness centers and prestigious educational institutions. See what's around our community and explore local favorites!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The Meyden in Bellevue, WA, luxury meets lifestyle. Enjoy evenings in our vibrant resident lounge, full kitchen, or unwind in the outdoor seating with fire pits. With modern apartments, from studios to two-bedrooms, and upscale amenities like a high-tech theater and paw spa, your ideal home awaits.",
  "property_applynow_blurb": "At The Meyden in Bellevue, WA, modern living meets effortless style. Choose from spacious studios to two-bedroom apartments, all featuring sleek quartz countertops and premium GE appliances. Enjoy community perks like a high-tech theater, sports lounge, and serene outdoor spaces. Your new home awaits—apply online today!",
  "property_contactus_blurb": "At The Meyden in Bellevue, WA, our varied floor plans—from cozy studios to spacious two-bedrooms—cater to every lifestyle. Whether you seek tranquility or connection, our thoughtfully designed spaces welcome you home. Have questions? Contact our leasing team today to find the perfect fit for your living needs!",
  "property_faqs_blurb": "At The Meyden in Bellevue, WA, we offer thoughtfully designed studio, one-bedroom, and two-bedroom apartments perfect for every lifestyle. Curious about our community? Visit our FAQs page to uncover all the details you need for a seamless living experience at The Meyden!",
  "property_floorplans_blurb": "At The Meyden in Bellevue, WA, we offer a diverse range of floor plans to fit your lifestyle. From cozy studios to spacious two-bedroom layouts, each design blends elegance and comfort. Browse our available apartment homes to find the perfect space that reflects your unique style and needs.",
  "property_gallery_blurb": "At The Meyden in Bellevue, WA, luxury and comfort intertwine. Picture yourself in a stylish studio or spacious two-bedroom, all featuring premium finishes like quartz countertops and energy-efficient appliances. Enjoy vibrant community amenities, from our high-tech theater to cozy outdoor fire pits, making every moment feel extraordinary.",
  "property_interactivemap_blurb": "Welcome to The Meyden in Bellevue, WA, where modern living meets ultimate comfort. Choose from stylish studio, one, or two-bedroom apartments featuring premium appliances, spacious balconies, and luxurious amenities like a sports lounge, high-tech theater, and cozy outdoor fire pits. Use our interactive community map to find your perfect apartment home today!",
  "property_pets_blurb": "At The Meyden in Bellevue, WA, your furry friends are part of the family! With spacious apartments for you and your pets, enjoy a welcoming environment for up to two pets. Just a few simple guidelines ensure a harmonious home for all—let the tails wag in your new abode!",
  "property_referafriend_blurb": "At The Meyden in Bellevue, WA, our diverse floor plans—from cozy studios to spacious two-bedroom apartments—cater to every lifestyle. With a welcoming community environment, great friends make great neighbors. Refer a friend today and let them experience the unique charm that The Meyden has to offer!",
  "property_residentaccess_blurb": "Welcome to The Meyden in Bellevue, WA! Access your resident portal for seamless rent payments, convenient maintenance requests, and an array of community updates. Whether you’re in a cozy studio or a spacious two-bedroom, we've crafted a home that's just right for you. Log in and elevate your living experience today!",
  "property_reviews_blurb": "At The Meyden, residents rave about our exceptional sense of community and attentive staff. As one happy tenant notes, “I think this is the first time ever I feel like home while staying at such a huge apartment complex.” Experience the unmatched comfort and service we provide in Bellevue, WA!",
  "property_created_at": "1743797426055",
  "property_scheduletour_blurb": "At The Meyden in Bellevue, WA, find your perfect space with our charming studio, one-bedroom, and two-bedroom floor plans. Experience community living that feels like home. Eager to know more? Schedule a tour today and hear firsthand what our residents love about their vibrant lifestyle at The Meyden!",
  "property_thankyou_blurb": "Thank you for reaching out! At The Meyden in Bellevue, WA, your next home awaits. Whether you’re drawn to our cozy studios or spacious two-bedroom apartments, a lifestyle of comfort and community is just a step away. Expect a friendly response from our team soon!",
  "property_virtualtours_blurb": "Experience the vibrant lifestyle at The Meyden in Bellevue, WA, where comfort meets modern elegance. From stylish studios to spacious two-bedroom apartments, our diverse floor plans cater to every need. Immerse yourself in our community—take a virtual tour today and envision your new home!",
  "property_copyright": "2025 All Rights Reserved. The Meyden",
  "property_seo_title_home": "The Meyden |  Apartments in Bellevue, WA",
  "property_seo_description_home": "Experience modern living at The Meyden in Bellevue, WA. Enjoy luxury amenities, spacious floor plans, and stunning views. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Bellevue, WA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at The Meyden in Bellevue, WA. From cozy studios to spacious two-bedrooms, browse our unique floor plans and elevate your lifestyle!",
  "property_seo_title_amenities": "Amenities | Bellevue, WA Apartments for Rent",
  "property_seo_description_amenities": "Experience vibrant living at The Meyden in Bellevue, WA! Enjoy luxe amenities—from a sports lounge to stunning city views. Your ideal home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Bellevue, WA",
  "property_seo_description_gallery": "Experience luxury living at The Meyden in Bellevue! Enjoy stunning floor plans, premium amenities, and vibrant community spaces. Picture your new home today!",
  "property_seo_title_virtualtours": "Virtual Tours | The Meyden Apartments",
  "property_seo_description_virtualtours": "Step inside The Meyden in Bellevue, WA! Take a virtual tour of our stylish studios and spacious one and two-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | The Meyden Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at The Meyden in Bellevue! Explore spacious studios and 1-2 bedroom apartments with exceptional amenities using our map!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Bellevue, WA",
  "property_seo_description_neighborhood": "Uncover Bellevue’s hidden gems near The Meyden. From cozy studios to spacious two-bedrooms, enjoy a vibrant neighborhood filled with local favorites!",
  "property_seo_title_contact": "Contact Us | The Meyden",
  "property_seo_description_contact": "Connect with The Meyden in Bellevue, WA! Explore our diverse floor plans from studios to two-bedrooms. Need help? Our leasing team is just a message away!",
  "property_seo_title_faqs": "FAQs | Apartments in Bellevue, WA",
  "property_seo_description_faqs": "Find answers to your questions about The Meyden in Bellevue, WA! Discover our unique amenities and floor plans to elevate your living experience.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Bellevue, WA",
  "property_seo_description_reviews": "Life at The Meyden in Bellevue, WA is vibrant! Check out our resident reviews to see why our community feels like home. Experience luxury and lifestyle!",
  "property_seo_title_applynow": "Apply Now | Apartments in Bellevue, WA",
  "property_seo_description_applynow": "Experience modern living at The Meyden in Bellevue, WA. Enjoy exceptional amenities, spacious floor plans, and stunning city views. Your new home awaits!",
  "property_seo_title_residentaccess": "Resident Access | The Meyden",
  "property_seo_description_residentaccess": "Unlock The Meyden resident portal for seamless rent payments, maintenance requests, and community updates. Your convenience awaits in Bellevue, WA!",
  "property_seo_title_referafriend": "Refer A Friend | The Meyden",
  "property_seo_description_referafriend": "Refer a friend to The Meyden in Bellevue, WA! Great friends make great neighbors—share the experience today and elevate your apartment living together!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Meyden",
  "property_seo_description_scheduletour": "Experience the charm of The Meyden in Bellevue, WA. Schedule a tour today and step into your future home in a vibrant community filled with luxury!",
  "property_seo_title_privacy": "Privacy Policy | The Meyden",
  "property_seo_description_privacy": "At The Meyden in Bellevue, WA, we prioritize your privacy. Read our policy to learn how we protect your personal information while you enjoy community living.",
  "property_seo_title_accessibility": "Website Accessibility | The Meyden",
  "property_seo_description_accessibility": "At The Meyden in Bellevue, WA, we prioritize digital inclusion. Experience a community where accessibility is woven into every corner. Join us today!",
  "property_seo_title_sitemap": "Sitemap | The Meyden",
  "property_seo_description_sitemap": "Navigate The Meyden in Bellevue, WA—your next home awaits! Check out our sitemap for a seamless journey through our vibrant community and amenities.",
  "property_seo_title_thankyou": "Thank You | The Meyden",
  "property_seo_description_thankyou": "Thanks for reaching out! The Meyden in Bellevue, WA, is excited to assist you. Expect a prompt reply from our team to help you find your perfect home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Bellevue, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1777625535440",
  "amenities": [
    {
      "id": "ec_53932f494d34d4a505fe3ef3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79293058",
      "title": "2 Stunning Exterior Courtyards with Texas Craft BBQs",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_87e4781953da584e42362547",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428270",
      "title": "Bike Racks",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_756c8d961bb8e7fd8c0756a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428273",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a92dd1dab8e5277a0a3ecbeb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428274",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f5c891b0224d6dc14d220cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428275",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1df36a7dfd7eff639483a224",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428278",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7847414e080c8f914ce340b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79293045",
      "title": "State of the Art Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df8fa2b3d8429987fcc80230",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428281",
      "title": "High Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d0709b926cae66fc36cc3dc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428283",
      "title": "Media Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_91001bfd68b74fe5385572d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428285",
      "title": "Off Street Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c7c1e9028720cf55cba5392d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428286",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51ff357c49877aafe5156608",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428288",
      "title": "Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d1b698424199a75d366d383",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428289",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc01420a32f938f33fccdde2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79293054",
      "title": "Sports Lounge with a Pool Table, Poker Table and Gaming Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d777d3cbf21fec95f033d68e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79293055",
      "title": "Resident Lounge with a Full Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e536a2a519f27f723db9f4dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79293056",
      "title": "High Tech Theater",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_58697e06ef9d591762616216",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79293057",
      "title": "Wi-Fi throughout the Common Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dad7b45646008f9fb2185ea1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79293059",
      "title": "Outdoor Seating with Fire Pits",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0a54e8d7acf66d8af55606d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79293060",
      "title": "Paw Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_af9888610f4bb99008ed6efe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79293061",
      "title": "Car Wash",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_550303d1d0ab338c55dc352e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79293062",
      "title": "Electric Car Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd03d07719a4ccbb528ef73b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79398638",
      "title": "Onsite Storage Units",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5d16ceb34dcc2170d6896fc2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79398639",
      "title": "Onsite Bike Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09a39665b521230e1276e920",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428269",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_58e28116a5837f1e74f2c326",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428272",
      "title": "Designer Carpeting in the Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_17c0b56ff6dc576b1397b4a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428277",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bf1d36cdad525e302e8b8803",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428279",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa11f7a234db6aa26e73fbfc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428292",
      "title": "Front Loading, full size Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1fadd415ed3444858f5b65ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428287",
      "title": "Large Private Patios, Balconies and Terraces *",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b9b40f5a41cc9ac98b114c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428271",
      "title": "Pre-Wired Fiber Optic Technology with choice of provider",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c837d858d35c1869fa1b4200",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428282",
      "title": "Spacious Walk-In Closets *",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4006f510f23b1ccdc28288fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428291",
      "title": "Vaulted Ceiling",
      "amount": "false",
      "description": "Vaulted Ceiling",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_453564ca1a74f12dacfa0d9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428293",
      "title": "Wheelchair Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0cd910385e6e03dcaa3c1eaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428294",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_247a7c40cd84479b294cf08e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79428280",
      "title": "Wood Flooring throughout Living Areas",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_610e0dbf6d66ed4790b55efe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "85760866",
      "title": "City View",
      "amount": "false",
      "description": "Prime Views of Downtown Bellevue",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac33c973ae7bfd92ff0fd059",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "85760867",
      "title": "Spacious Balcony",
      "amount": "false",
      "description": "Spacious Balcony",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_14e4caae8e592604066b10e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "85760868",
      "title": "Private Balcony",
      "amount": "false",
      "description": "Private Balcony",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_41133090b1f8032c8f236511",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "85760869",
      "title": "Courtyard Patio",
      "amount": "false",
      "description": "Courtyard Patio",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_81cbfc6d527b761ae0083b4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "85760870",
      "title": "Terrace",
      "amount": "false",
      "description": "Terrace",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c74faee2ad690c7ff0003134",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79465228",
      "title": "Custom Self-Closing Cabinets and Drawers",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c3f3b429c677a01701090d3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79465227",
      "title": "Ice Makers in every Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_add8b36481b27ed9ba734a69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79465233",
      "title": "Linen Closets *",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ba003acb453a6fbb0bd6f9da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79465210",
      "title": "Mobile Kitchen Islands",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bd7a6721d4e8b5aa07585f13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79465231",
      "title": "Pantry Closets *",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c1a45a9f33dd87f4fc290fdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79465232",
      "title": "Porcelain Tile Flooring in the Bathroom",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_178798df211cb8cb3b03c61d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79465211",
      "title": "Premium GE, Stainless Steel Energy Efficient Appliances to include Refrigerator, Microwave, Dishwasher and Stove",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d69e1b81b36cc82422d7280",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79465209",
      "title": "Quartz Stone Countertops with Undermount Sink in Kitchen and Bath",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ffc5e29712d58105ab1d1012",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79465230",
      "title": "Tile Backsplashes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69fbd825f10cb61316d33145",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "yardi",
      "external_id": "79465229",
      "title": "Wood-Grain Cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_3c0be88e74e1c54605ca954b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-486a-70cc-be71-7f9d8cf097f9.webp",
      "image_media": {
        "alt_text": "Outdoor water feature with seating and grilling area.",
        "public_id": "019d0812-486a-70cc-be71-7f9d8cf097f9",
        "storage_key": "property/6767906449164266/019d0812-486a-70cc-be71-7f9d8cf097f9.webp",
        "width": 1000,
        "height": 679
      },
      "title": "Community",
      "description": "Enjoy the refreshing outdoor water feature, perfect for relaxing, alongside a modern outdoor kitchen and dining area.",
      "link": "false",
      "alt_text": "Outdoor water feature with seating and grilling area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/464900/The Meyden Amenities - Private Courtyard.jpg"
    },
    {
      "id": "ec_e4a839b706dbdc893f28de85",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-5102-7682-a23b-7cac3cbc9310.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a comfortable sectional sofa, vibrant green accent chair, and a large television on the wall.",
        "public_id": "019d0812-5102-7682-a23b-7cac3cbc9310",
        "storage_key": "property/6767906449164266/019d0812-5102-7682-a23b-7cac3cbc9310.webp",
        "width": 1877,
        "height": 1080
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge, featuring comfortable seating and entertainment options for residents.",
      "link": "false",
      "alt_text": "Modern lounge area with a comfortable sectional sofa, vibrant green accent chair, and a large television on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/464900/Tekla Lounge.jpg"
    },
    {
      "id": "ec_8415e49850b7be8fe5a6f535",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-4c99-7666-ac42-7a8f160710bb.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with blue bar stools and stainless steel appliances.",
        "public_id": "019d0812-4c99-7666-ac42-7a8f160710bb",
        "storage_key": "property/6767906449164266/019d0812-4c99-7666-ac42-7a8f160710bb.webp",
        "width": 1254,
        "height": 1080
      },
      "title": "Apartment",
      "description": "A sleek kitchen island with bar stools, perfect for casual dining or entertaining, featuring modern stainless steel appliances.",
      "link": "false",
      "alt_text": "Modern kitchen island with blue bar stools and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/464900/Tekla Lounge(1).jpg"
    },
    {
      "id": "ec_b2ebea474612ecf83e81598b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-473b-7092-85f8-ed2d9f67158d.webp",
      "image_media": {
        "alt_text": "Modern lobby with brick accent wall, abstract pendant lights, and comfortable seating area.",
        "public_id": "019d0812-473b-7092-85f8-ed2d9f67158d",
        "storage_key": "property/6767906449164266/019d0812-473b-7092-85f8-ed2d9f67158d.webp",
        "width": 1678,
        "height": 925
      },
      "title": "Community",
      "description": "Welcome guests into our stylish lobby, featuring elegant decor and ample seating for a comfortable and inviting atmosphere.",
      "link": "false",
      "alt_text": "Modern lobby with brick accent wall, abstract pendant lights, and comfortable seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/464900/lobby.JPG"
    },
    {
      "id": "ec_fd824be769c664a7216e027b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-53d2-775c-a9d8-fe430164d48f.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen bed, two accent chairs, and artwork.",
        "public_id": "019d0812-53d2-775c-a9d8-fe430164d48f",
        "storage_key": "property/6767906449164266/019d0812-53d2-775c-a9d8-fe430164d48f.webp",
        "width": 1669,
        "height": 878
      },
      "title": "Apartment",
      "description": "A beautifully appointed bedroom featuring a comfortable queen-sized bed, two stylish accent chairs, and tasteful wall art, creating a serene and inviting living space.",
      "link": "false",
      "alt_text": "Bedroom with a queen bed, two accent chairs, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/464900/studio2.JPG"
    },
    {
      "id": "ec_dba13c1b2976296366924167",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-5865-7710-9384-41497bc9c4bf.webp",
      "image_media": {
        "alt_text": "A modern studio apartment featuring a bed, desk, kitchen, and hallway.",
        "public_id": "019d0812-5865-7710-9384-41497bc9c4bf",
        "storage_key": "property/6767906449164266/019d0812-5865-7710-9384-41497bc9c4bf.webp",
        "width": 1663,
        "height": 758
      },
      "title": "Apartment",
      "description": "A stylish studio apartment with a comfortable bed, a functional desk area, a compact kitchen, and a hallway leading to the entrance.",
      "link": "false",
      "alt_text": "A modern studio apartment featuring a bed, desk, kitchen, and hallway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/464900/studio1.jpg"
    },
    {
      "id": "ec_a06849991b2d32826d08f195",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-64b5-776d-92dd-5207daddfb74.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, and weight machines",
        "public_id": "019d0812-64b5-776d-92dd-5207daddfb74",
        "storage_key": "property/6767906449164266/019d0812-64b5-776d-92dd-5207daddfb74.webp",
        "width": 1901,
        "height": 1080
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a variety of cardio machines and strength-training equipment for residents.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, ellipticals, and weight machines",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/464900/gym.jpg"
    },
    {
      "id": "ec_e26bd809634a71f852d769cf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-63f8-736f-a629-1fb2040f2400.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, wood cabinets, and a dining area.",
        "public_id": "019d0812-63f8-736f-a629-1fb2040f2400",
        "storage_key": "property/6767906449164266/019d0812-63f8-736f-a629-1fb2040f2400.webp",
        "width": 1200,
        "height": 758
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample cabinet space, and a contemporary design. Perfect for cooking and dining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, wood cabinets, and a dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/464900/Kitchen.jpg"
    },
    {
      "id": "ec_2dbb770d6987d8aef5d0877a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-6137-769d-85f4-4440f13f982c.webp",
      "image_media": {
        "alt_text": "The Meyden logo: stylized M inside a diamond shape with surrounding geometric elements.",
        "public_id": "019d0812-6137-769d-85f4-4440f13f982c",
        "storage_key": "property/6767906449164266/019d0812-6137-769d-85f4-4440f13f982c.webp",
        "width": 528,
        "height": 307
      },
      "title": "Logo",
      "description": "The official logo for The Meyden, featuring a distinctive geometric design with the letter M at its center.",
      "link": "false",
      "alt_text": "The Meyden logo: stylized M inside a diamond shape with surrounding geometric elements.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/464900/The Meyden Logo - White.png"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_e6de4cec-0722-4aff-aea9-3afa67d2cd05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Amazon Dynamo Bellevue",
      "poi_type": "Major Employers & Offices",
      "poi_address": "85 106th Ave NE, Bellevue, WA 98004, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-c0a2-70f8-bcbe-e11c09593156.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-c0a2-70f8-bcbe-e11c09593156",
        "storage_key": "property/6767906449164266/019dbbe6-c0a2-70f8-bcbe-e11c09593156.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1851289622254184634&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amazon-dynamo-bellevue",
      "poi_latitude": "47.6103683",
      "poi_longitude": "-122.1991578",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b8f3-7459-95ae-b582ce3fff42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b8f3-7459-95ae-b582ce3fff42",
        "storage_key": "property/6767906449164266/019d0813-b8f3-7459-95ae-b582ce3fff42.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1-hhQgBtkFQRuujTVhoasRk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_05f2b940-afdc-468d-aee3-7d296bda483e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Smartsheet Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 108th Ave NE #200, Bellevue, WA 98004, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-bf19-75db-b0fc-f49d8791dec5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-bf19-75db-b0fc-f49d8791dec5",
        "storage_key": "property/6767906449164266/019dbbe6-bf19-75db-b0fc-f49d8791dec5.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.smartsheet.com/?refid=googlemaps-utm_source=googlemaps&utm_medium=map-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12771529597400551693&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "smartsheet-inc",
      "poi_latitude": "47.6150107",
      "poi_longitude": "-122.1957478",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-324-2360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b8f3-7459-95ae-b582ce3fff42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b8f3-7459-95ae-b582ce3fff42",
        "storage_key": "property/6767906449164266/019d0813-b8f3-7459-95ae-b582ce3fff42.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAZOyO49skFQRDZFym4CWPbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_214deeb4-2e49-4927-aa23-c9740ff00526",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "T-Mobile Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3625 132nd Ave SE, Bellevue, WA 98006, USA",
      "poi_short_description": "Wireless provider offering cell phones, data plans, Internet devices & accessories.",
      "poi_long_description": "Wireless provider offering cell phones, data plans, Internet devices & accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d6ce1-333f-732a-a213-4873d27b82d7.webp",
      "poi_featured_image_media": {
        "alt_text": "Pink unicorn statue with rainbow mane and tail, featuring the T-Mobile logo.",
        "public_id": "019d6ce1-333f-732a-a213-4873d27b82d7",
        "storage_key": "property/6767906449164266/019d6ce1-333f-732a-a213-4873d27b82d7.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13157546119071260821&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "t-mobile-corporate-office",
      "poi_latitude": "47.578474",
      "poi_longitude": "-122.1656899",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 855-977-5086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b8f3-7459-95ae-b582ce3fff42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b8f3-7459-95ae-b582ce3fff42",
        "storage_key": "property/6767906449164266/019d0813-b8f3-7459-95ae-b582ce3fff42.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY06QCapukFQRleAPz3v-mLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_45d50fe0-76f5-4360-a71e-a547756f0b63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Overlake Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1035 116th Ave NE, Bellevue, WA 98004, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-becd-7515-a064-006d531c4e6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-becd-7515-a064-006d531c4e6e",
        "storage_key": "property/6767906449164266/019dbbe6-becd-7515-a064-006d531c4e6e.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.overlakehospital.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14792161275466343213&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "overlake-medical-center",
      "poi_latitude": "47.6208526",
      "poi_longitude": "-122.1869157",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-688-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b8f3-7459-95ae-b582ce3fff42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b8f3-7459-95ae-b582ce3fff42",
        "storage_key": "property/6767906449164266/019d0813-b8f3-7459-95ae-b582ce3fff42.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl9mHnO1skFQRLeN1zE5QSM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_d1d09313-2fd8-410b-89ea-85434d02e30f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "The Pokémon Company International",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10400 NE 4th St Unit 2800, Bellevue, WA 98004, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-c46c-760c-9924-865f8b40ff90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-c46c-760c-9924-865f8b40ff90",
        "storage_key": "property/6767906449164266/019dbbe6-c46c-760c-9924-865f8b40ff90.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "http://pokemon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13701492210734799165&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-pokmon-company-international",
      "poi_latitude": "47.6142184",
      "poi_longitude": "-122.2008553",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-222-1970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b8f3-7459-95ae-b582ce3fff42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b8f3-7459-95ae-b582ce3fff42",
        "storage_key": "property/6767906449164266/019d0813-b8f3-7459-95ae-b582ce3fff42.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf2fwDQptkFQRPRmhcZJ6Jb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_2b552359-1233-49ee-bec7-10a8fc1ad056",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Dough Zone Dumpling House Bellevue",
      "poi_type": "Restaurants",
      "poi_address": "10300 Main St Suite E, Bellevue, WA 98004, USA",
      "poi_short_description": "Casual Asian restaurant serving traditional comfort dishes, such as soup dumplings and noodle soups.",
      "poi_long_description": "People say this Asian restaurant serves delicious dan dan noodles, dumplings, and cucumber salad. They also highlight the friendly staff and quick service.\n\nOther reviews mention the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-c733-74c0-985c-007ca5bbeaab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-c733-74c0-985c-007ca5bbeaab",
        "storage_key": "property/6767906449164266/019dbbe6-c733-74c0-985c-007ca5bbeaab.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://doughzonedumplinghouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11292887205060127406&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dough-zone-dumpling-house-bellevue",
      "poi_latitude": "47.6103292",
      "poi_longitude": "-122.2025855",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-454-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b1b7-71bc-8622-3dd265fc0832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b1b7-71bc-8622-3dd265fc0832",
        "storage_key": "property/6767906449164266/019d0813-b1b7-71bc-8622-3dd265fc0832.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl0CSabBtkFQRrqopqhRluJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "custom_011e965b-7961-4bc2-a2df-a9f111f26ae3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Adrian’s Restaurant & Tequila Bar",
      "poi_type": "Restaurants",
      "poi_address": "10145 Main St, Bellevue, WA 98004, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this Mexican restaurant serves high-end dishes, such as salmon over spinach and lamb shank. They highlight the delicious food, perfect margaritas, and tasty mango drinks. They also like the friendly and attentive service, and the elegant, family-run atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-cbee-72de-ae7e-f9493b85b7b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-cbee-72de-ae7e-f9493b85b7b2",
        "storage_key": "property/6767906449164266/019dbbe6-cbee-72de-ae7e-f9493b85b7b2.webp",
        "width": 1280,
        "height": 813
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17947017580538398059&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "adrians-restaurant--tequila-bar",
      "poi_latitude": "47.6100135",
      "poi_longitude": "-122.2043399",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b1b7-71bc-8622-3dd265fc0832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b1b7-71bc-8622-3dd265fc0832",
        "storage_key": "property/6767906449164266/019d0813-b1b7-71bc-8622-3dd265fc0832.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVTZ2UuttkFQRa4Wu8WadEPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_4eda73d3-e462-4cf3-b3fc-f044587d4804",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Peony Kitchen Bellevue",
      "poi_type": "Restaurants",
      "poi_address": "10317 Main St # 100, Bellevue, WA 98004, USA",
      "poi_short_description": "Rustic-chic eatery with wood & exposed brick walls, serving Chinese fare with a contemporary twist.",
      "poi_long_description": "People say this Chinese restaurant serves delicious dishes, including crispy duck, squid ink fried rice, and mapo tofu. They also highlight the generous portions, good value for money, and welcoming atmosphere.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-cce2-73ab-b54f-9194ea67be73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-cce2-73ab-b54f-9194ea67be73",
        "storage_key": "property/6767906449164266/019dbbe6-cce2-73ab-b54f-9194ea67be73.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.peonykitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5543981753346105301&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "peony-kitchen-bellevue",
      "poi_latitude": "47.60995279999999",
      "poi_longitude": "-122.2028278",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-502-7652",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b1b7-71bc-8622-3dd265fc0832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b1b7-71bc-8622-3dd265fc0832",
        "storage_key": "property/6767906449164266/019d0813-b1b7-71bc-8622-3dd265fc0832.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW9I35X1skFQR1R9xCQgu8Ew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_92cf68fa-9035-410c-a295-ef490cdf96da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Valentinas Wine Bar",
      "poi_type": "Restaurants",
      "poi_address": "10204 Main St, Bellevue, WA 98004, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this wine bar offers a great selection of wine by the the glass or bottle, as well as tasty flatbreads and charcuterie boards. They highlight the relaxed and comfortable vibe, and the attentive service. They also like the knowledgeable and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-cd8a-76fd-8f3a-5a53d02488ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-cd8a-76fd-8f3a-5a53d02488ae",
        "storage_key": "property/6767906449164266/019dbbe6-cd8a-76fd-8f3a-5a53d02488ae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.valentinas-winebar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18155859062784836572&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "valentinas-wine-bar",
      "poi_latitude": "47.6103684",
      "poi_longitude": "-122.2037876",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe7-0084-74d8-b8d9-7e7769096c4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dbbe7-0084-74d8-b8d9-7e7769096c4f",
        "storage_key": "property/6767906449164266/019dbbe7-0084-74d8-b8d9-7e7769096c4f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAUEdaABtkFQR3MNYrZ-R9vs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "custom_86577d95-273f-4565-8ffa-aa0adaa33a52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Bis on Main",
      "poi_type": "Restaurants",
      "poi_address": "10213 Main St, Bellevue, WA 98004, USA",
      "poi_short_description": "Classy, white-tablecloth American spot with European edge & more-casual lounge offering happy hour.",
      "poi_long_description": "People say this restaurant serves delicious dishes, including French toast, quiche, and beignets. They also highlight the attentive service and enjoyable atmosphere.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-d682-74ad-b2a0-6f89ece0dda2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-d682-74ad-b2a0-6f89ece0dda2",
        "storage_key": "property/6767906449164266/019dbbe6-d682-74ad-b2a0-6f89ece0dda2.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://bobbymoorerestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13743966489520330801&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bis-on-main",
      "poi_latitude": "47.61005",
      "poi_longitude": "-122.203833",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-455-2033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b1b7-71bc-8622-3dd265fc0832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b1b7-71bc-8622-3dd265fc0832",
        "storage_key": "property/6767906449164266/019d0813-b1b7-71bc-8622-3dd265fc0832.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ25WyBn5skFQRMVi7HLRgvL4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "custom_c9b504e0-11ed-4cd0-a945-cd6246091ee4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Bellevue Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "575 Bellevue Square, Bellevue, WA 98004, USA",
      "poi_short_description": "Sprawling venue that includes retail shops, casual & upscale dining options & a comedy club.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including major anchors like Nordstrom and Macy's, as well as popular brands such as Uniqlo and Zara. They highlight the clean and well-maintained environment, convenient amenities like ample parking and a children's play area, and the festive decorations during holidays. They also like the friendly staff and the live piano music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-5ed3-7418-af58-3e28a61132a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0813-5ed3-7418-af58-3e28a61132a0",
        "storage_key": "property/6767906449164266/019d0813-5ed3-7418-af58-3e28a61132a0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://bellevuecollection.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15740512561876323718&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bellevue-square",
      "poi_latitude": "47.6157647",
      "poi_longitude": "-122.203721",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-454-8096",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b1b7-71bc-8622-3bba9945d0e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b1b7-71bc-8622-3bba9945d0e8",
        "storage_key": "property/6767906449164266/019d0813-b1b7-71bc-8622-3bba9945d0e8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJF7Wdd4ZskFQRhk02OceIcdo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_082bd3ad-02bf-4681-961a-dde062000523",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Lincoln Square South",
      "poi_type": "Shopping & Retail",
      "poi_address": "500 Bellevue Way NE, Bellevue, WA 98004, USA",
      "poi_short_description": "Mall with art, dozens of stores, several restaurants, a multiplex, entertainment venues & hotels.",
      "poi_long_description": "People say this shopping center offers a wide variety of dining options, from casual cafes to award-winning restaurants, as well as high-end shopping and entertainment, including a movie theater and bowling alley. They also highlight the clean, safe, and upscale environment, with many mentioning the festive holiday decorations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-d51e-704b-b201-9ca655fb6b88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-d51e-704b-b201-9ca655fb6b88",
        "storage_key": "property/6767906449164266/019dbbe6-d51e-704b-b201-9ca655fb6b88.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bellevuecollection.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6722500302138345530&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lincoln-square-south",
      "poi_latitude": "47.6142475",
      "poi_longitude": "-122.2007738",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-646-3660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b1b7-71bc-8622-3bba9945d0e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b1b7-71bc-8622-3bba9945d0e8",
        "storage_key": "property/6767906449164266/019d0813-b1b7-71bc-8622-3bba9945d0e8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJG586rIhskFQROohpT2geS10",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_60f44dd2-bf80-4f56-8072-2ad2bfc9e1bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "300 Bellevue Way NE, Bellevue, WA 98004, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "People say this grocery store has a convenient pharmacy and offers digital downloads for coupons. They also highlight that it's a great place to find snacks.\n\nSome reviews mention the customer service can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-d3b2-7799-9afb-ce5b128c9b71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-d3b2-7799-9afb-ce5b128c9b71",
        "storage_key": "property/6767906449164266/019dbbe6-d3b2-7799-9afb-ce5b128c9b71.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://local.safeway.com/safeway/wa/bellevue/300-bellevue-way-ne.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=2819219688218658712&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "47.6130672",
      "poi_longitude": "-122.200964",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-749-3885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b1b0-774b-b05a-49166c930664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b1b0-774b-b05a-49166c930664",
        "storage_key": "property/6767906449164266/019d0813-b1b0-774b-b05a-49166c930664.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ55QQpIdskFQRmIcPnF7hHyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4219b769-28e1-43a7-91fd-90c71d910afa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "H Mart Bellevue",
      "poi_type": "Shopping & Retail",
      "poi_address": "100 108th Ave NE 108 & Main, Bellevue, WA 98004, USA",
      "poi_short_description": "Grocer with a focus on Asian ingredients, plus a sushi counter and a bakery.",
      "poi_long_description": "People say this Korean grocery store offers a wide selection of fresh produce, seafood, snacks, and a variety of Asian goods. They also highlight the attached bakery with fresh pastries and beautiful cakes, and the convenient parking.\n\nOther reviews mention the store can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-d62c-72eb-bad8-b6d92be8dede.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-d62c-72eb-bad8-b6d92be8dede",
        "storage_key": "property/6767906449164266/019dbbe6-d62c-72eb-bad8-b6d92be8dede.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hmartus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7972729689131450463&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "h-mart-bellevue",
      "poi_latitude": "47.6110483",
      "poi_longitude": "-122.1958515",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-990-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b1b0-774b-b05a-49166c930664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b1b0-774b-b05a-49166c930664",
        "storage_key": "property/6767906449164266/019d0813-b1b0-774b-b05a-49166c930664.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP4RnMn1skFQRXwDkMmnTpG4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_bc14fcb2-a0d4-4b7d-8e8b-dda2fb6fc43a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "107 Bellevue Way SE, Bellevue, WA 98004, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-dbcd-73ab-a243-ce3e55195263.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-dbcd-73ab-a243-ce3e55195263",
        "storage_key": "property/6767906449164266/019dbbe6-dbcd-73ab-a243-ce3e55195263.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/bellevue-wa-pharmacies/107-bellevue-way-se-bellevue-wa-98004/storeid=10619?WT.mc_id=LS_GOOGLE_FS_10619",
      "poi_directions_map_url": "https://maps.google.com/?cid=4632435178539412841&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "47.6095822",
      "poi_longitude": "-122.2018023",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-454-1818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b8f3-7459-95ae-b582ce3fff42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b8f3-7459-95ae-b582ce3fff42",
        "storage_key": "property/6767906449164266/019d0813-b8f3-7459-95ae-b582ce3fff42.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS9BQ2n1skFQRaW3dTUC3SUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_e65c998f-1d5d-430d-b32d-fcc7129fb8c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Bubble Planet: An Immersive Experience - Bellevue",
      "poi_type": "Entertainment",
      "poi_address": "103 110th Ave NE, Bellevue, WA 98004, USA",
      "poi_short_description": "Family-friendly venue featuring immersive photo ops, virtual reality experiences and staff.",
      "poi_long_description": "Visitors say this event venue offers a fun, family-friendly experience with interactive rooms, including a ball pit, balloon room, and bubble bath, as well as photo ops and a gift shop. They also highlight the friendly staff and immersive experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-df2a-731a-9975-57a88a20fa6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-df2a-731a-9975-57a88a20fa6a",
        "storage_key": "property/6767906449164266/019dbbe6-df2a-731a-9975-57a88a20fa6a.webp",
        "width": 1080,
        "height": 720
      },
      "poi_business_url": "https://bubble-planet.com/seattle/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11949185513740305334&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bubble-planet-an-immersive-experience---bellevue",
      "poi_latitude": "47.6115421",
      "poi_longitude": "-122.1940925",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b8f3-7459-95ae-b582ce3fff42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b8f3-7459-95ae-b582ce3fff42",
        "storage_key": "property/6767906449164266/019d0813-b8f3-7459-95ae-b582ce3fff42.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy_fbPwBtkFQRtgO8TeoI1KU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_083cc34c-1000-45c5-8544-8e1c00e765be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Theatre At Meydenbauer Center",
      "poi_type": "Entertainment",
      "poi_address": "11100 NE 6th St, Bellevue, WA 98004, USA",
      "poi_short_description": "Dance performances, cultural arts & arts education at a 410-seat theater within a convention center.",
      "poi_long_description": "Dance performances, cultural arts & arts education at a 410-seat theater within a convention center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-e003-7188-aa6e-b1e6079e6590.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-e003-7188-aa6e-b1e6079e6590",
        "storage_key": "property/6767906449164266/019dbbe6-e003-7188-aa6e-b1e6079e6590.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://meydenbauer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15877318525977150887&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "theatre-at-meydenbauer-center",
      "poi_latitude": "47.615599",
      "poi_longitude": "-122.1912949",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-450-3810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b8f3-7459-95ae-b582ce3fff42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b8f3-7459-95ae-b582ce3fff42",
        "storage_key": "property/6767906449164266/019d0813-b8f3-7459-95ae-b582ce3fff42.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2z4DiolskFQRp8WY5hORV9w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_9a94577c-7e04-4130-b3a7-0bfda20495d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Cinemark Reserve Lincoln Square — Dine-In 21+",
      "poi_type": "Entertainment",
      "poi_address": "500 Bellevue Way NE suit 340, Bellevue, WA 98004, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "People say this movie theater offers comfortable reclining seats, a variety of food and drink options, and seat-side service. They also highlight the clean and well-maintained facilities, the fun activities like pool and shuffleboard, and the friendly and efficient service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-e065-75b2-9e64-92c9e5307219.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-e065-75b2-9e64-92c9e5307219",
        "storage_key": "property/6767906449164266/019dbbe6-e065-75b2-9e64-92c9e5307219.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/wa-bellevue/cinemark-reserve-lincoln-square-dine-in-21-plus?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMxODEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13085402499012239272&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cinemark-reserve-lincoln-square--dine-in-21",
      "poi_latitude": "47.614579",
      "poi_longitude": "-122.20126",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-455-8422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe7-02b9-7043-90f8-4bf1ea7dfe03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dbbe7-02b9-7043-90f8-4bf1ea7dfe03",
        "storage_key": "property/6767906449164266/019dbbe7-02b9-7043-90f8-4bf1ea7dfe03.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJadMls4hskFQRqB-iUD6wmLU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_75bcad64-e690-4138-bce6-ea5601c60a99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Dave & Buster's Bellevue",
      "poi_type": "Entertainment",
      "poi_address": "11639 NE 4th St, Bellevue, WA 98004, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "People say this restaurant offers tasty burgers, wings, and nachos, as well as a variety of drinks, including margaritas and beer. They also highlight the fun atmosphere with a wide selection of arcade games, and the friendly and attentive service.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-e544-749d-acc1-d8ff4e9f66f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-e544-749d-acc1-d8ff4e9f66f7",
        "storage_key": "property/6767906449164266/019dbbe6-e544-749d-acc1-d8ff4e9f66f7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.daveandbusters.com/us/en/about/locations/bellevue",
      "poi_directions_map_url": "https://maps.google.com/?cid=15461037696196928033&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dave--busters-bellevue",
      "poi_latitude": "47.6127262",
      "poi_longitude": "-122.1845741",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-372-2550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b1b7-71bc-8622-3dd265fc0832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b1b7-71bc-8622-3dd265fc0832",
        "storage_key": "property/6767906449164266/019d0813-b1b7-71bc-8622-3dd265fc0832.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk6fobfttkFQRIeK9XN6jkNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ce001947-9c1f-4c77-b5a3-e24fcb99622a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Reality Break Escapes | RBE Team Events",
      "poi_type": "Entertainment",
      "poi_address": "225 106th Ave NE, Bellevue, WA 98004, USA",
      "poi_short_description": "Friendly-staffed entertainment center for interactive escape games, puzzle hunts and other activities.",
      "poi_long_description": "People say this escape room center offers a variety of fun and challenging rooms with creative puzzles. They highlight the logical puzzles, great setup, and the overall fun experience. They also like the friendly, welcoming, and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-e765-750b-adbb-5db74421cf67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-e765-750b-adbb-5db74421cf67",
        "storage_key": "property/6767906449164266/019dbbe6-e765-750b-adbb-5db74421cf67.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://realitybreakescapes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7796739587926223107&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "reality-break-escapes--rbe-team-events",
      "poi_latitude": "47.61279",
      "poi_longitude": "-122.1993",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-577-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b8f3-7459-95ae-b582ce3fff42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b8f3-7459-95ae-b582ce3fff42",
        "storage_key": "property/6767906449164266/019d0813-b8f3-7459-95ae-b582ce3fff42.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3R9ClmVtkFQRA2mRqFiVM2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_d37737b6-6202-4806-88e0-da6f778faead",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Bellevue College",
      "poi_type": "Education",
      "poi_address": "3000 Landerholm Cir SE, Bellevue, WA 98007, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-6526-70fe-9d76-b545b978adb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0813-6526-70fe-9d76-b545b978adb6",
        "storage_key": "property/6767906449164266/019d0813-6526-70fe-9d76-b545b978adb6.webp",
        "width": 1280,
        "height": 858
      },
      "poi_business_url": "https://www.bellevuecollege.edu/?utm_source=google&utm_medium=gmb&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13504348681346997872&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bellevue-college",
      "poi_latitude": "47.5843272",
      "poi_longitude": "-122.1481496",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-564-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b1b6-740e-8a7f-34ce2edda0a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b1b6-740e-8a7f-34ce2edda0a6",
        "storage_key": "property/6767906449164266/019d0813-b1b6-740e-8a7f-34ce2edda0a6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZWLQKB5skFQRcN6zmpMVabs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_dafddd8c-40a4-44ba-b295-c1c9d339712c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Bellevue High School",
      "poi_type": "Education",
      "poi_address": "10416 SE Wolverine Way, Bellevue, WA 98004, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-e9f0-777e-8554-578f83e03ce3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-e9f0-777e-8554-578f83e03ce3",
        "storage_key": "property/6767906449164266/019dbbe6-e9f0-777e-8554-578f83e03ce3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bellevuehigh.bsd405.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5970382464911105376&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bellevue-high-school",
      "poi_latitude": "47.6051544",
      "poi_longitude": "-122.1968293",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-456-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b1b6-740e-8a7f-34ce2edda0a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b1b6-740e-8a7f-34ce2edda0a6",
        "storage_key": "property/6767906449164266/019d0813-b1b6-740e-8a7f-34ce2edda0a6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAydDC3lskFQRYF0_KjgP21I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_e1d92d2b-f631-44d9-80e1-849d1e9311b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "International School",
      "poi_type": "Education",
      "poi_address": "445 128th Ave SE, Bellevue, WA 98005, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-e9ce-7023-8924-2e757da272fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-e9ce-7023-8924-2e757da272fa",
        "storage_key": "property/6767906449164266/019dbbe6-e9ce-7023-8924-2e757da272fa.webp",
        "width": 1200,
        "height": 674
      },
      "poi_business_url": "http://www.bsd405.org/international/",
      "poi_directions_map_url": "https://maps.google.com/?cid=348005767531945689&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "international-school",
      "poi_latitude": "47.6042055",
      "poi_longitude": "-122.17131",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-456-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b1b6-740e-8a7f-34ce2edda0a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b1b6-740e-8a7f-34ce2edda0a6",
        "storage_key": "property/6767906449164266/019d0813-b1b6-740e-8a7f-34ce2edda0a6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdypwg2lskFQR2V6H2WZd1AQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_6d35a4e3-58de-4828-ac99-689c6c765d64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Clyde Hill Elementary School",
      "poi_type": "Education",
      "poi_address": "9601 NE 24th St, Clyde Hill, WA 98004, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-f09f-700f-bd95-d356d2088688.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-f09f-700f-bd95-d356d2088688",
        "storage_key": "property/6767906449164266/019dbbe6-f09f-700f-bd95-d356d2088688.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bsd405.org/clydehill",
      "poi_directions_map_url": "https://maps.google.com/?cid=5652127566544314473&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "clyde-hill-elementary-school",
      "poi_latitude": "47.6310496",
      "poi_longitude": "-122.2114749",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-456-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b1b6-740e-8a7f-34ce2edda0a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b1b6-740e-8a7f-34ce2edda0a6",
        "storage_key": "property/6767906449164266/019d0813-b1b6-740e-8a7f-34ce2edda0a6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdZU8Cr5skFQRaSARVRNkcE4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_2d997373-f31c-48b6-bcde-24ca41fe855f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Chinook Middle School",
      "poi_type": "Education",
      "poi_address": "2001 98th Ave NE, Bellevue, WA 98004, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-efb3-77dc-ac78-189fa5aa83d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-efb3-77dc-ac78-189fa5aa83d2",
        "storage_key": "property/6767906449164266/019dbbe6-efb3-77dc-ac78-189fa5aa83d2.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://chinook.bsd405.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12138539471933774332&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chinook-middle-school",
      "poi_latitude": "47.6283042",
      "poi_longitude": "-122.2107482",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-456-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b1b6-740e-8a7f-34ce2edda0a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b1b6-740e-8a7f-34ce2edda0a6",
        "storage_key": "property/6767906449164266/019d0813-b1b6-740e-8a7f-34ce2edda0a6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz4uQXZZskFQR_JmrRFbBdKg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6baca3a2-7cb2-446b-b299-8c75178a3118",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Meydenbauer Bay Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "419 98th Ave NE, Bellevue, WA 98004, USA",
      "poi_short_description": "This 2.5-acre beach offers in-season swimming plus a fishing dock & play/picnic areas.",
      "poi_long_description": "Visitors say this park offers stunning waterfront views of Lake Washington, a sandy beach, and a nature-inspired playground. They also highlight the well-maintained park, walking paths, and pedestrian pier, perfect for relaxing and enjoying the outdoors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-f1c2-7425-bf36-666ffc26f37a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-f1c2-7425-bf36-666ffc26f37a",
        "storage_key": "property/6767906449164266/019dbbe6-f1c2-7425-bf36-666ffc26f37a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bellevuewa.gov/city-government/departments/parks/parks-and-trails/parks/meydenbauer-beach-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15139820113588723733&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "meydenbauer-bay-park",
      "poi_latitude": "47.6124346",
      "poi_longitude": "-122.211107",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-452-6885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-bd02-7542-97ec-d27d346512dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-bd02-7542-97ec-d27d346512dd",
        "storage_key": "property/6767906449164266/019d0813-bd02-7542-97ec-d27d346512dd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1ysjdIFskFQRFSDF2S1yG9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f8e9f1fb-8ae6-46dc-99f1-d9814d96669f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Bellevue Downtown Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10201 NE 4th St, Bellevue, WA 98004, USA",
      "poi_short_description": "Lushly planted city park featuring a 240-foot-wide waterfall, a picnic green & a playground.",
      "poi_long_description": "Visitors say this urban park offers a playground, walking paths, a large lawn for picnics, and a water feature with ducks. They also highlight the park's clean and well-maintained facilities, family-friendly atmosphere, and convenient location near shops and restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-f13e-737c-9eae-cd84172339ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-f13e-737c-9eae-cd84172339ac",
        "storage_key": "property/6767906449164266/019dbbe6-f13e-737c-9eae-cd84172339ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parks.bellevuewa.gov/parks-and-trails/parks/bellevue-downtown-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4725159899354261845&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bellevue-downtown-park",
      "poi_latitude": "47.6126836",
      "poi_longitude": "-122.2041686",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-452-6885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-bd02-7542-97ec-d27d346512dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-bd02-7542-97ec-d27d346512dd",
        "storage_key": "property/6767906449164266/019d0813-bd02-7542-97ec-d27d346512dd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYVqRI4dskFQRVWnuu-Qjk0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_32f6180a-e535-4bc5-ac2f-df5f90b25082",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Bellevue Pickleball Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "44 Bellevue Way NE, Bellevue, WA 98004, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this pickleball court offers new facilities, great lighting, and comfortable courts. They highlight the convenient location, easy parking, and spacious practice studio. They also like the friendly and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-f813-7015-8da0-ce8c034fda42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-f813-7015-8da0-ce8c034fda42",
        "storage_key": "property/6767906449164266/019dbbe6-f813-7015-8da0-ce8c034fda42.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thebellevuepickleballclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18355900018953461930&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bellevue-pickleball-club",
      "poi_latitude": "47.6111216",
      "poi_longitude": "-122.2007564",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-866-7678",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b8f3-7459-95ae-b582ce3fff42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b8f3-7459-95ae-b582ce3fff42",
        "storage_key": "property/6767906449164266/019d0813-b8f3-7459-95ae-b582ce3fff42.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWdJU1zttkFQRqqBOQtBBvf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "custom_b9f63967-1f0b-4263-be43-611a3f673dd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Clyde Beach Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2 92nd Ave NE, Bellevue, WA 98004, USA",
      "poi_short_description": "Small bayside park with a swimming beach, also featuring a boathouse, playground & picnic area.",
      "poi_long_description": "People say this park offers a playground, swimming area, and fishing opportunities. They highlight the beautiful, quiet, and relaxing atmosphere, as well as the well-maintained green space and charming waterfront. They also like the clear water and stunning views of Meydenbauer Bay, especially during sunset and sunrise.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-fa60-7329-9311-7291d5daf701.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-fa60-7329-9311-7291d5daf701",
        "storage_key": "property/6767906449164266/019dbbe6-fa60-7329-9311-7291d5daf701.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bellevuewa.gov/city-government/departments/parks/parks-and-trails/parks/clyde-beach-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10217075906984549052&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "clyde-beach-park",
      "poi_latitude": "47.6145303",
      "poi_longitude": "-122.2173931",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-452-6885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-bd02-7542-97ec-d27d346512dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-bd02-7542-97ec-d27d346512dd",
        "storage_key": "property/6767906449164266/019d0813-bd02-7542-97ec-d27d346512dd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu6whhoJskFQRvBoEr2dYyo0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_232caa8e-12c9-4750-bee0-d42831e86ea1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "poi_name": "Sammamish Animal Sanctuary",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16515 SE May Valley Rd, Renton, WA 98059, USA",
      "poi_short_description": "Nonprofit sanctuary housing barnyard animals that provides free public access.",
      "poi_long_description": "People say this animal sanctuary offers a variety of animals that visitors can feed and interact with, including goats, highland cows, and miniature horses. They highlight the fun and educational experience, especially for children, and the opportunity to support a good cause. They also like the friendly and helpful staff, and the well-maintained facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019dbbe6-fa26-76f4-894a-14d92ae0d972.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-fa26-76f4-894a-14d92ae0d972",
        "storage_key": "property/6767906449164266/019dbbe6-fa26-76f4-894a-14d92ae0d972.webp",
        "width": 1067,
        "height": 800
      },
      "poi_business_url": "http://www.sammamishanimalsanctuary.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17524446031676298309&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sammamish-animal-sanctuary",
      "poi_latitude": "47.5022484",
      "poi_longitude": "-122.1207346",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-877-9002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0813-b8f3-7459-95ae-b582ce3fff42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-b8f3-7459-95ae-b582ce3fff42",
        "storage_key": "property/6767906449164266/019d0813-b8f3-7459-95ae-b582ce3fff42.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTX8tXz5ukFQRRdSRO9FWM_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pet_care"
    }
  ],
  "office_hours": [
    {
      "id": "ec_95b0d0a6364f705d15f5d39f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_0c4d27ae6201cd63982f045c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e00f67881beabb599a0749ae",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_86a8a1f265ceeef807273b48",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6243b0f60a45feb2158f4185",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_9b81b705a0f8bf5ff409b365",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_22e25e0b-6afa-42d6-a101-8eecbb4a0079",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "rating": "5.0",
      "name": "Daniel Deutsch",
      "text": "My wife and I both love living here. Meyden has by far the best leasing office that either have us have worked with. They are friendly, helpful, and responsive. Same goes for the maintenance team. While we were out of town for the holidays, they helped us through a move to a bigger unit, which we were so grateful for.\n\nMeyden's location is perfect, at the corner of Bellevue Way and Main Street, and its gym is the best I've seen at any apartment.\n\nIt also has a nice sense of community that other buildings lack, with well organized, friendly events each month.\n\nIt's a lovely place to live, and we'd recommend it.",
      "date": "2025-02-06",
      "title": ""
    },
    {
      "id": "custom_395a0d3b-b4c1-4e6e-8b03-c205e24d3664",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "rating": "5.0",
      "name": "Margaret Cohen",
      "text": "I have an experience living in different apartment complexes in different states and cities. The Meyden is by far the best place I’ve ever rented my apartment at. Bree is the most friendly person you’ll ever meet and the maintenance team is awesome. You will fall in love with the location too. I think this is the first time ever I feel like home while staying at such a huge apartment complex. Highly recommend!",
      "date": "2020-12-11",
      "title": ""
    },
    {
      "id": "custom_67854ef6-df8e-4114-af17-3f915deef07a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "rating": "5.0",
      "name": "Tala Buwadi",
      "text": "I’ve been meaning to write a review for The Meyden for a while, because I remember I was pretty hesitant about moving here after seeing past reviews. But I need the world to know how great of a place this is, especially for someone like me who was moving from across the country and needed to sign a lease for a place without getting to see it in person. In short, the tour & application process was super easy and smooth, moving in and living there was great, I had a great experience parking my car in the garage, and upon move out I wasn’t charged any fees except a $200 cleaning fee.\n\nFirst of all they showed me multiple units over video before I leased, sending me numerous pictures as well and answering questions promptly (almost always got replies shortly after emailing). I asked many questions about the various units and about the general leasing process as it was my first time & they were happy to help. The process of applying & getting approved was super quick, I believe I got approved a few hours after applying. Before I moved, I asked if I can ship a couple things to the apartment & they let me do that + also took all the boxes into my unit as they arrived to avoid them getting stolen. They also helped coordinate a way for me to get my keys at 11 pm, because I had a late flight into the city.\n\nUpon moving in, I had absolutely no issues. If I needed something I could go down to the leasing office and ask and there was usually multiple people in the office during business hours willing to help. Or if I had a maintenance issue (I only had 1 or 2 minor things) they came and fixed that within hours of putting in the maintenance request. The fixtures and appliances are super high quality. Every single person I interacted with from the leasing staff to the maintenance crew to the property manager were just so so nice. Giustin, Zach, Jojo, Michael, everyone!! They also had regular events planned for residents that would get posted in the elevator but I didn’t end up going to those. The buildings gym is also open 24 hrs which was nice.\n\nI also got parking for my car, and had absolutely no issues. I felt like my car was safe in the garage, and the parking spots are pretty wide, and the garage is also not too full so I didn’t even have to park beside another car. You get an assigned spot, and I didn’t like my original spot so I asked if I could change it and right away they gave me a new spot. The garage has a gate for additional security from the public parking, and is also well lit so felt safe being there at all times. It’s also really convenient that the garage has tons of public parking spots, because friends can just park in those for 3 hrs for free when visiting. And if they’re visiting overnight the leasing office will give you a pass to allow them to park there for a longer period.\n\nBefore moving out I asked if I could extend the lease by a couple days, and the property manager did that for me right away. I ended up needing to change it back to the original date, and he changed it back for me, no questions asked. Upon moving out I wasn’t charged any fees besides a cleaning fee ($200). But I did take lots of pics and make lots of notes during the move in inspection of any pre-existing wear and tear I saw, so I’m sure that helped for me to not get charged for anything I didn’t do. And they really encouraged being detailed in that move in form which was great.\n\nOverall, highly recommend the Meyden!! I ended up moving out after a year to experience living in seattle, but if I was ever back in Bellevue I’d move back!!",
      "date": "2025-02-14",
      "title": ""
    },
    {
      "id": "custom_785583a7-acbf-4dfd-bcbf-e2cefdd88e14",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "rating": "5.0",
      "name": "Rachael Sera",
      "text": "I lived at The Meyden until 2021 and loved my apartment and still have fond memories of it. The fixtures are much higher quality than other apartments nearby (lovely countertops with undermount sink, actual slide-in range, laminate wood plank floors), it had AC, and my unit was super quiet (I was on the top floor, but never heard adjacent neighbors or people in the hall). I liked the garage parking, and the car wash station in the garage was a blessing. The staff was very pleasant and accommodating upon move out (no high or unexpected fees, although I did keep the place very clean while I was there). If it still made sense for me to be renting in Bellevue, The Meyden would again be my first choice.",
      "date": "2023-03-17",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_42f35baf-f515-4b0d-bce1-ef43f4799385",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d6dbb-2c42-7239-b7fb-19ca7b37b02f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d6dbb-2c42-7239-b7fb-19ca7b37b02f",
        "storage_key": "property/6767906449164266/019d6dbb-2c42-7239-b7fb-19ca7b37b02f.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "The Meyden",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?id=pano-8894269&tour=63b30826a72972189bca5f8f"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a3127-3068-73f7-ab85-dad1631763e3",
      "lead_source": "LANDING_PAGE",
      "name": "The Meyden landing page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266"
    },
    {
      "lead_collector_id": "019a3127-3113-72af-81ae-887af9a9da26",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Meyden property website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "luxury-apartments-city-view-bellevue-the-meyden",
      "search_query": "luxury apartments with city view Bellevue",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with City View Bellevue",
      "h2_subtitle": "Experience luxury living with a stunning city view in Bellevue. Discover your perfect home at The Meyden today.",
      "page_copy": "Welcome to The Meyden, where luxury apartments with city view Bellevue redefine upscale living. Nestled in the heart of West Bellevue, our community offers an elegant array of studio, one, and two-bedroom homes, each with breathtaking cityscape vistas. Picture yourself unwinding on your private balcony, savoring the stunning panoramas that Bellevue is known for.\n\nAt The Meyden, luxury is present in every detail. Revel in modern conveniences such as porcelain tile flooring in the bathrooms and custom self-closing cabinets. Meet friends in our high-tech theater or relax by the fire pits in our outdoor seating area. Immerse yourself in the perfect blend of luxury and leisure in one of Bellevue's most desirable neighborhoods.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with City View Bellevue",
      "seo_description": "Discover luxury apartments with city views in Bellevue at The Meyden. Enjoy modern amenities and breathtaking panoramas in the heart of Bellevue.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "private-balcony-apartments-west-bellevue-the-meyden",
      "search_query": "private balcony apartments West Bellevue",
      "category": "Amenity",
      "h1_title": "Private Balcony Apartments West Bellevue",
      "h2_subtitle": "Enjoy the charm of West Bellevue from your private balcony. The Meyden offers stunning views and exceptional amenities.",
      "page_copy": "Discover The Meyden's private balcony apartments West Bellevue, where comfort meets style. Our luxurious studio, one, and two-bedroom homes provide the perfect retreat with private balconies offering stunning panoramas of the vibrant Bellevue skyline. Whether you're sipping coffee at sunrise or unwinding at sunset, your balcony will quickly become a cherished spot.\n\nLocated in West Bellevue, our community boasts a host of exceptional amenities to elevate your lifestyle. Indulge in modern touches like porcelain tile-floor bathrooms and custom cabinetry in every home. Socialize with neighbors in our high-tech theater or by the warm glow of our outdoor fire pits. Embrace the seamless blend of luxury and convenience at The Meyden.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Private Balcony Apartments West Bellevue",
      "seo_description": "The Meyden offers private balcony apartments in West Bellevue. Enjoy stunning views and modern amenities in this luxurious community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "sports-lounge-apartments-king-county-the-meyden",
      "search_query": "sports lounge apartments King County",
      "category": "Amenity",
      "h1_title": "Sports Lounge Apartments King County",
      "h2_subtitle": "Find your perfect home with a sports lounge in King County. The Meyden offers luxury living with unique amenities.",
      "page_copy": "Welcome to The Meyden, the premier destination for sports lounge apartments King County. Located in vibrant West Bellevue, our luxury community offers residents a unique blend of leisure and elegance. Our sports lounge is the perfect spot to relax after a long day, watch a game with friends, or strike up a conversation with neighbors.\n\nIn addition to our enticing sports lounge, The Meyden features luxurious studio, one, and two-bedroom apartment homes equipped with modern amenities like porcelain tile bathroom flooring and custom cabinetry. Enjoy private balconies with stunning city views, and unwind by our outdoor fire pits. Elevate your lifestyle in a community designed with the utmost attention to detail and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sports Lounge Apartments King County",
      "seo_description": "Discover sports lounge apartments in King County at The Meyden. Enjoy luxury living with modern amenities in a prime Bellevue location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "stainless-steel-appliances-bellevue-wa-the-meyden",
      "search_query": "stainless steel appliances Bellevue WA",
      "category": "Amenity",
      "h1_title": "Stainless Steel Appliances Bellevue WA",
      "h2_subtitle": "Explore upscale living with stainless steel appliances in Bellevue, WA. The Meyden offers modern luxury in the heart of the city.",
      "page_copy": "At The Meyden, discover upscale residences with stainless steel appliances Bellevue WA. Our stylish studio, one, and two-bedroom apartments are designed with modern conveniences to enhance your lifestyle. Stainless steel appliances seamlessly blend with custom self-closing cabinets and drawers, creating a kitchen that's both functional and elegant.\n\nLocated in West Bellevue, The Meyden offers more than just beautiful interiors. Experience community amenities like a high-tech theater and cozy outdoor seating with fire pits. Each home also features a private balcony with awe-inspiring views of the city's skyline. Realize the perfect balance of luxury and comfort at The Meyden, where every detail is crafted with care.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stainless Steel Appliances Bellevue WA",
      "seo_description": "The Meyden offers residences with stainless steel appliances in Bellevue, WA. Experience modern living with luxurious amenities and stunning city views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "theater-room-apartments-98004-the-meyden",
      "search_query": "theater room apartments 98004",
      "category": "Amenity",
      "h1_title": "Theater Room Apartments 98004",
      "h2_subtitle": "Enjoy exclusive living in 98004 with our theater room. The Meyden offers luxury amenities in the heart of Bellevue.",
      "page_copy": "Experience exceptional living with theater room apartments 98004 at The Meyden. Our luxurious community in vibrant Bellevue offers an exclusive high-tech theater room perfect for movie nights or watching your favorite sports events with neighbors and friends. Enjoy a cinematic experience without leaving the comfort of home.\n\nBeyond our impressive theater room, The Meyden features contemporary studio, one, and two-bedroom apartments with modern amenities. Each home comes with a private balcony offering stunning Bellevue views. Unique touches like porcelain tile bathroom floors and custom cabinetry provide an elegant living experience. Discover unparalleled luxury and convenience at The Meyden, right in the heart of prestigious 98004.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Theater Room Apartments 98004",
      "seo_description": "The Meyden offers theater room apartments in 98004, Bellevue. Enjoy luxury living with modern amenities and exclusive cinematic experiences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "studio-apartments-near-west-bellevue-the-meyden",
      "search_query": "studio apartments near West Bellevue",
      "category": "Floorplan",
      "h1_title": "Studio Apartments Near West Bellevue",
      "h2_subtitle": "Discover chic studio apartments near West Bellevue. The Meyden offers modern amenities in a prime location.",
      "page_copy": "Discover sophisticated studio apartments near West Bellevue at The Meyden. Our stylish living spaces are thoughtfully designed with modern amenities, providing a perfect retreat in the bustling city of Bellevue. Each studio features luxurious finishes like porcelain tile flooring in the bathroom, custom self-closing cabinets, and private balconies with captivating city views.\n\nLocated in the heart of West Bellevue, The Meyden goes beyond beautiful interiors with community features like a high-tech theater and outdoor seating areas complete with fire pits. These extraordinary amenities blend seamlessly with the surrounding vibrant neighborhood. Choose The Meyden for an unparalleled living experience that combines elegance, comfort, and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments Near West Bellevue",
      "seo_description": "Find chic studio apartments near West Bellevue at The Meyden. Enjoy luxurious living with modern amenities and stunning city views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-bellevue-wa-the-meyden",
      "search_query": "one bedroom apartments Bellevue WA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Bellevue WA",
      "h2_subtitle": "Explore luxury one bedroom apartments in Bellevue, WA. The Meyden offers modern living with exceptional amenities.",
      "page_copy": "Discover luxurious one bedroom apartments Bellevue WA at The Meyden, where each unit is designed for style and comfort. Our well-appointed apartments feature modern amenities, including stainless steel appliances and custom self-closing cabinets. Spacious interiors are complemented by private balconies offering stunning city views, making it the perfect urban retreat.\n\nLocated in the heart of Bellevue, The Meyden provides residents with an array of exclusive amenities. From a high-tech theater and enticing outdoor seating with fire pits to convenient pantry closets, our community is crafted for comfort and leisure. Experience the perfect blend of elegance and functionality in Bellevue's vibrant environment at The Meyden.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Bellevue WA",
      "seo_description": "The Meyden offers one bedroom apartments in Bellevue, WA, with modern amenities and stunning views. Experience luxury living at its finest.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-in-king-county-the-meyden",
      "search_query": "two bedroom apartments in King County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in King County",
      "h2_subtitle": "Explore spacious two bedroom apartments in King County. The Meyden offers luxury living with top-notch amenities.",
      "page_copy": "Discover the elegance of two bedroom apartments in King County at The Meyden, located in the vibrant city of Bellevue. Our spacious two-bedroom units are beautifully designed with luxurious features like porcelain tile bathroom floors and custom cabinetry, offering an unparalleled living experience.\n\nAt The Meyden, you're not just getting a home; you're joining a community where leisure meets luxury. Enjoy amenities such as a high-tech theater perfect for movie nights and outdoor areas with cozy fire pits for social gatherings. Situated in a prime location, The Meyden provides convenient access to the best of King County, ensuring a balanced lifestyle of work, play, and relaxation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in King County",
      "seo_description": "The Meyden offers luxurious two bedroom apartments in King County. Experience top-notch amenities and spacious living in a prime Bellevue location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "apartments-near-bellevue-college-wa-the-meyden",
      "search_query": "apartments near bellevue college wa",
      "category": "School",
      "h1_title": "Apartments Near Bellevue College WA",
      "h2_subtitle": "Find modern apartments near Bellevue College, WA. The Meyden offers convenience and luxury living just minutes away.",
      "page_copy": "Experience stylish living at The Meyden, offering premier apartments near Bellevue College, WA. Our studio, one, and two-bedroom units are equipped with modern amenities designed to enhance your living experience. Each apartment features custom self-closing cabinets and stunning city views from private balconies, ideal for students and professionals alike.\n\nThe Meyden is not just about luxurious interiors; it offers a vibrant community setting with amenities such as a high-tech theater and outdoor seating areas complete with fire pits for relaxation and entertainment. Conveniently located mere minutes from Bellevue College, The Meyden is perfect for those looking to balance academic life with urban comfort and style.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bellevue College WA",
      "seo_description": "Explore The Meyden's luxurious apartments near Bellevue College, WA. Enjoy modern amenities and prime location, perfect for students and professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "apartments-close-to-university-of-washington-king-county",
      "search_query": "apartments close to university of washington king county",
      "category": "School",
      "h1_title": "Apartments Close to University of Washington",
      "h2_subtitle": "Discover stylish apartments close to the University of Washington in King County. The Meyden offers luxurious living just a short drive away.",
      "page_copy": "Situated in the heart of Bellevue, The Meyden provides luxurious apartments close to the University of Washington, King County. Our selection of studio, one, and two-bedroom apartments are designed with modern amenities, including spacious floor plans and custom cabinetry, facilitating a comfortable and sophisticated lifestyle.\n\nLiving at The Meyden means you’re part of a vibrant community with exclusive amenities such as a high-tech theater and outdoor relaxation areas featuring fire pits. Perfectly positioned for easy access to the University of Washington, you'll enjoy the convenience of urban living alongside the tranquility of a residential neighborhood. Embrace the best of both worlds at The Meyden.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to University of Washington",
      "seo_description": "The Meyden offers luxurious apartments close to the University of Washington, King County. Enjoy modern living with convenient access to campus life.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "apartments-near-seattle-central-college-bellevue-the-meyden",
      "search_query": "apartments near seattle central college in bellevue",
      "category": "School",
      "h1_title": "Apartments Near Seattle Central College Bellevue",
      "h2_subtitle": "Discover premium apartments near Seattle Central College in Bellevue. The Meyden offers the perfect combination of luxury and convenience.",
      "page_copy": "Located in the vibrant city of Bellevue, The Meyden presents exquisite apartments near Seattle Central College, blending luxury with accessibility. Choose from our stylish studio, one, or two-bedroom units, all featuring modern amenities such as custom self-closing cabinets and stunning views of the cityscape.\n\nEnhance your lifestyle with our community's exclusive offerings, including a state-of-the-art high-tech theater and inviting outdoor seating areas complete with fire pits. The Meyden's prime location ensures that reaching Seattle Central College is straightforward and hassle-free, making it an ideal choice for academic professionals and students seeking a sophisticated living environment in Bellevue.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Seattle Central College Bellevue",
      "seo_description": "The Meyden offers luxurious apartments near Seattle Central College in Bellevue. Experience modern amenities and convenient access to education and entertainment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "bellevue-apartments-near-seattle-university-98004-the-meyden",
      "search_query": "bellevue apartments near seattle university in 98004",
      "category": "School",
      "h1_title": "Bellevue Apartments Near Seattle University",
      "h2_subtitle": "Explore luxurious Bellevue apartments near Seattle University in the 98004 area. The Meyden offers premier living and amenities close by.",
      "page_copy": "The Meyden offers luxury Bellevue apartments near Seattle University in the 98004 zip code. Nestled in the West Bellevue neighborhood, our stylish studio, one, and two-bedroom apartments come with state-of-the-art features like porcelain tile flooring in the bathrooms and expansive city views, perfect for students and faculty desiring proximity to the university.\n\nEnjoy the blend of leisure and luxury with amenities such as custom self-closing cabinets, a high-tech theater, and relaxing outdoor areas with fire pits. Conveniently located just a short drive from Seattle University, The Meyden provides not only comfort and style but also easy access to the university campus and all the vibrant activities downtown Bellevue has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bellevue Apartments Near Seattle University",
      "seo_description": "Discover luxurious Bellevue apartments near Seattle University. The Meyden, in the 98004 zip code, offers stunning amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "apartments-near-seattle-childrens-hospital-bellevue-the-meyden",
      "search_query": "apartments near seattle children's hospital bellevue",
      "category": "Hospital",
      "h1_title": "Apartments Near Seattle Children's Hospital",
      "h2_subtitle": "Find exceptional apartments near Seattle Children's Hospital in Bellevue. The Meyden offers luxury living with convenient access.",
      "page_copy": "Nestled in Bellevue, The Meyden offers luxurious apartments near Seattle Children's Hospital, providing an ideal living environment for healthcare professionals and families seeking both convenience and comfort. Our elegant studio, one, and two-bedroom apartments feature premium amenities such as pantry closets and high-tech theater access, exemplifying a sophisticated lifestyle.\n\nBeyond the superb accommodations, enjoy community amenities like outdoor seating with fire pits and modern living spaces designed for relaxation and entertainment. Positioned conveniently close to Seattle Children's Hospital, the Meyden ensures a quick and straightforward commute, allowing residents to make the most of their lifestyle and leisure time in a vibrant urban setting.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Seattle Children's Hospital",
      "seo_description": "Discover The Meyden's luxury apartments near Seattle Children's Hospital in Bellevue, offering modern amenities and convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "harborview-medical-center-nearby-apartments-king-county-the-meyden",
      "search_query": "harborview medical center nearby apartments in king county",
      "category": "Hospital",
      "h1_title": "Nearby Apartments: Harborview Medical Center",
      "h2_subtitle": "Discover King County apartments near Harborview Medical Center. The Meyden offers luxury living with unmatched convenience.",
      "page_copy": "The Meyden in Bellevue offers premium King County apartments conveniently located near Harborview Medical Center. Perfect for healthcare professionals and their families, our community provides the opportunity to reside in luxury while enjoying quick access to the medical center. Our stylish apartments feature modern amenities like custom self-closing cabinets and porcelain tile bathrooms, ideal for those seeking both luxury and functionality.\n\nResidents of The Meyden can unwind in our sports lounge or appreciate evenings by the outdoor fire pits. Located within easy reach of Harborview Medical Center, our community ensures a seamless commute, leaving more time to enjoy the vibrant attractions and dining experiences Bellevue and the surrounding King County have to offer. Experience the best of both worlds with a sophisticated living environment and unmatched proximity to essential services.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Harborview Medical Center",
      "seo_description": "Find luxury apartments near Harborview Medical Center in King County. The Meyden offers premier living with easy access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "apartments-near-marymoor-park-redmond-the-meyden",
      "search_query": "apartments near Marymoor Park Redmond",
      "category": "Park",
      "h1_title": "Apartments Near Marymoor Park, Redmond",
      "h2_subtitle": "Explore luxury apartments near Marymoor Park in Redmond. The Meyden in Bellevue offers modern living with a touch of nature.",
      "page_copy": "Situated in the heart of Bellevue, The Meyden provides luxurious apartments conveniently located near Marymoor Park in Redmond. Ideal for those who appreciate nature and modern living, our community offers easy access to the park's vast green spaces, trails, and recreational activities. Residents enjoy stylish studio, one, and two-bedroom options featuring high-end amenities like custom self-closing cabinets and serene private balconies.\n\nAt The Meyden, unwind in our high-tech theater or gather with friends around the outdoor fire pits. For nature enthusiasts, the proximity to Marymoor Park ensures quick trips to enjoy picnics, sports, and concerts. Experience a blend of city sophistication and natural beauty with a residence at The Meyden, where every feature is designed to enhance your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Marymoor Park, Redmond",
      "seo_description": "Discover luxury apartments near Marymoor Park in Redmond. The Meyden offers elegant living amidst nature and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "seward-park-area-apartments-bellevue-the-meyden",
      "search_query": "Seward Park area apartments Bellevue",
      "category": "Park",
      "h1_title": "Seward Park Area Apartments, Bellevue",
      "h2_subtitle": "Discover stunning apartments in the Seward Park area of Bellevue. The Meyden offers luxury living close to nature and city conveniences.",
      "page_copy": "The Meyden, located in Bellevue, offers premium living options for those seeking proximity to the beautiful Seward Park area. Featuring luxurious studio, one, and two-bedroom apartments, our community caters to those who appreciate both urban convenience and green spaces. With modern amenities such as porcelain tile bathrooms and private balconies, residents can enjoy a high standard of living.\n\nOur community's amenities include an outdoor seating area with fire pits and a high-tech theater, creating a perfect balance between relaxation and entertainment. Proximity to Seward Park provides the ideal opportunity for outdoor adventures, while Bellevue's vibrant urban setting offers unlimited dining and shopping experiences. Experience the peace of mind that comes with living close to Seward Park while enjoying the luxurious comforts at The Meyden.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Seward Park Area Apartments in Bellevue",
      "seo_description": "Explore luxury apartments near Seward Park in Bellevue. The Meyden offers modern amenities and lush surroundings close to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "apartments-near-warren-g-magnuson-park-seattle-the-meyden",
      "search_query": "apartments near Warren G. Magnuson Park Seattle",
      "category": "Park",
      "h1_title": "Apartments Nearby Magnuson Park, Seattle",
      "h2_subtitle": "Experience luxury living near Warren G. Magnuson Park in Seattle. The Meyden offers top-notch apartments with scenic views and modern amenities.",
      "page_copy": "Located in Bellevue, The Meyden is the perfect choice for those seeking luxurious apartments near Warren G. Magnuson Park in Seattle. Our stylish studio, one, and two-bedroom apartments feature modern amenities like custom self-closing cabinets and porcelain tile flooring, ideal for residents who value both comfort and style.\n\nEnjoy the convenience of living near the expansive Warren G. Magnuson Park, providing endless opportunities for outdoor recreation and relaxation. The Meyden further enhances your lifestyle with a high-tech theater and cozy outdoor seating complete with fire pits. Immerse yourself in the vibrant Bellevue and Seattle areas while enjoying the unparalleled comforts and convenience offered at The Meyden.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Magnuson Park, Seattle",
      "seo_description": "Find luxury apartments near Magnuson Park in Seattle. The Meyden offers modern amenities and proximity to beautiful outdoor spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "bellevue-downtown-park-nearby-apartments-the-meyden",
      "search_query": "Bellevue Downtown Park nearby apartments",
      "category": "Park",
      "h1_title": "Apartments Near Bellevue Downtown Park",
      "h2_subtitle": "Discover luxury living in apartments near Bellevue Downtown Park. The Meyden offers modern amenities just steps from this beautiful urban oasis.",
      "page_copy": "At The Meyden, enjoy a luxurious lifestyle just moments away from Bellevue Downtown Park. Offering upscale studio, one, and two-bedroom apartments, our community is perfect for those who want easy access to the vibrant heart of Bellevue. Our modern amenities, including custom cabinetry and private balconies with stunning city views, ensure comfort and elegance.\n\nOur residents benefit from close proximity to Bellevue Downtown Park, featuring expansive green spaces and cultural events, offering a perfect blend of recreation and relaxation. Enjoy evenings in our sports lounge or by the fire pits, and savor the convenience of city living with the tranquility of parkland. Choose The Meyden for unparalleled comfort and a prime location near one of Bellevue's finest parks.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bellevue Downtown Park",
      "seo_description": "Live in style near Bellevue Downtown Park. The Meyden offers luxury apartments with modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "washington-park-arboretum-bellevue-area-apartments-the-meyden",
      "search_query": "Washington Park Arboretum Bellevue area apartments",
      "category": "Park",
      "h1_title": "Apartments Near Washington Park Arboretum",
      "h2_subtitle": "Explore luxury living near Washington Park Arboretum in Bellevue. The Meyden offers modern apartments with easy access to nature and city life.",
      "page_copy": "The Meyden is your gateway to upscale living near the Washington Park Arboretum in Bellevue. Our studio, one, and two-bedroom apartments are designed with modern conveniences, such as porcelain tiles and custom cabinets, creating a luxurious living experience. Situated within reach of the arboretum, residents can enjoy both lush greenery and urban comforts.\n\nExperience the vibrant lifestyle of Bellevue, with its shopping and dining, while having the serenity of the Washington Park Arboretum nearby for leisurely walks and botanical exploration. Our community offers amenities like outdoor seating areas with fire pits and a high-tech theater, making home life as exciting as the attractions surrounding you. Choose The Meyden and enjoy the best of both worlds—nature and city within reach.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Washington Park Arboretum",
      "seo_description": "Discover The Meyden's luxury apartments near Washington Park Arboretum. Prime location with modern amenities and access to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-washington-station-the-meyden",
      "search_query": "apartments near university of washington station 98004",
      "category": "Transit",
      "h1_title": "Apartments Near Univ. of Washington Station",
      "h2_subtitle": "Discover stylish apartments near University of Washington Station in Bellevue. The Meyden offers convenience, modern amenities, and a vibrant community.",
      "page_copy": "For those seeking apartments near University of Washington Station in the 98004 area, The Meyden presents an ideal choice. Offering a selection of stylish studio, one, and two-bedroom apartments, this community provides easy transit access combined with luxurious living. Enjoy modern features like custom self-closing cabinets and private balconies that offer a relaxing escape with city views.\n\nResidents of The Meyden benefit from being just a short commute away from the University of Washington Station, facilitating effortless access to academic pursuits, shopping, and dining in nearby Seattle. Our amenities, including a sports lounge and outdoor fire pits, offer relaxation after a busy day. Embrace a perfect blend of convenience and luxury at The Meyden, with all the vibrant opportunities of Bellevue at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Univ. of Washington Station",
      "seo_description": "Find luxury apartments near University of Washington Station. The Meyden offers convenience and modern amenities in Bellevue.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "luxury-apartments-close-to-sodo-station-the-meyden",
      "search_query": "luxury apartments close to sodo station bellevue",
      "category": "Transit",
      "h1_title": "Luxury Apartments Near SoDo Station",
      "h2_subtitle": "Experience luxury living close to SoDo Station in Bellevue. The Meyden offers stylish apartments with modern amenities and convenient access.",
      "page_copy": "For those searching for luxury apartments close to SoDo Station in Bellevue, The Meyden is an exceptional choice. Nestled in the heart of Bellevue, our studio, one, and two-bedroom apartments offer a blend of modern elegance and convenience. With high-end features like porcelain tile flooring and private balconies, residents experience comfort in every detail.\n\nLocated conveniently near SoDo Station, The Meyden is perfect for commuters who desire seamless access to the greater Seattle area. Enjoy the amenities of a high-tech theater and sports lounge, providing a relaxing retreat after a busy day. With Bellevue's vibrant lifestyle at your doorstep, The Meyden strikes the perfect balance between luxury home life and urban accessibility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments Near SoDo Station",
      "seo_description": "Discover luxury living at The Meyden, close to SoDo Station. Experience modern amenities and convenience in Bellevue's vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "apartments-west-bellevue-near-international-district-the-meyden",
      "search_query": "apartments in west bellevue near international district/chinatown",
      "category": "Transit",
      "h1_title": "Apartments in West Bellevue Near ID/Chinatown",
      "h2_subtitle": "Live in vibrant West Bellevue, close to the International District/Chinatown. The Meyden offers modern living with cultural convenience.",
      "page_copy": "Located in the heart of West Bellevue, The Meyden offers stylish studio, one, and two-bedroom apartments that provide easy access to the International District/Chinatown. Our residents enjoy a unique blend of suburban tranquility and urban convenience, with modern amenities such as custom self-closing cabinets and panoramic city views.\n\nThe Meyden is just a short distance from the cultural and culinary delights found in the International District/Chinatown. Whether you are commuting or exploring, our location ensures you're always connected. Enjoy the luxury and leisure of amenities like outdoor fire pits and a high-tech theater, making it easy to unwind after a day in the city. Choose The Meyden for a dynamic lifestyle that celebrates both Bellevue's charm and Seattle's rich cultural tapestry.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts in West Bellevue Near Intl District/Chinatown",
      "seo_description": "Discover The Meyden's modern apartments in West Bellevue, near Intl District/Chinatown. Enjoy culture and convenience in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "king-county-apartments-near-columbia-city-station-the-meyden",
      "search_query": "king county apartments near columbia city station",
      "category": "Transit",
      "h1_title": "King County Apartments Near Columbia City",
      "h2_subtitle": "Explore The Meyden, King County's luxury apartments near Columbia City Station. Enjoy modern amenities and stylish living in Bellevue.",
      "page_copy": "In search of King County apartments near Columbia City Station? Look no further than The Meyden in Bellevue. Offering stylish studio, one, and two-bedroom apartments equipped with high-end amenities like pantry closets and porcelain tile flooring, The Meyden represents the epitome of modern living.\n\nLocated strategically, The Meyden ensures seamless access to Columbia City Station, enhancing the convenience for daily commuters. Bellevue's vibrant community offers an array of dining and entertainment options, while our on-site amenities, such as the sports lounge and high-tech theater, provide a perfect backdrop for leisure and relaxation. Discover contemporary living with all the perks of urban connectivity at The Meyden.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "King County Apts Near Columbia City Station",
      "seo_description": "The Meyden offers luxury living in King County near Columbia City Station. Experience modern amenities in a vibrant Bellevue community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164266",
      "source": "generator",
      "page_item_url": "modern-apartments-near-mount-baker-station-the-meyden",
      "search_query": "modern apartments near mount baker station wa",
      "category": "Transit",
      "h1_title": "Modern Apartments Near Mount Baker Station",
      "h2_subtitle": "Discover The Meyden's modern living near Mount Baker Station, WA. Enjoy luxurious amenities and a convenient Bellevue location.",
      "page_copy": "For those seeking modern apartments near Mount Baker Station in WA, The Meyden in Bellevue offers an ideal home base. Our contemporary studio, one, and two-bedroom apartments are designed with luxury and functionality in mind, featuring custom self-closing cabinets and private balconies with exceptional views.\n\nSituated with easy access to Mount Baker Station, The Meyden is perfect for those who value connectivity and convenience. Whether you're commuting or exploring, our location keeps you close to everything the region has to offer. Relish in amenities like outdoor seating with fire pits and a high-tech theater, ensuring your living experience is both comfortable and enjoyable. Choose The Meyden for a stylish and accessible lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio with a modern fire pit, wicker chairs, and dining tables.",
        "public_id": "019d0812-f8c4-773c-a699-7b44c7325abe",
        "storage_key": "property/6767906449164266/019d0812-f8c4-773c-a699-7b44c7325abe.webp",
        "width": 1000,
        "height": 594
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments by Mount Baker Station",
      "seo_description": "Experience The Meyden's modern apartments near Mount Baker Station, WA. Luxurious living with prime connectivity in Bellevue.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4928"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9241077743"
    },
    {
      "ID": "custom_pay_rent_url",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TVSNQF3X"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"https://webchat.omni.cafe/conversations/3bee234b-db22-4d05-a479-725b22138ac8/app.js?property=3bee234b-db22-4d05-a479-725b22138ac8&amp;propertyName=The+Meyden&amp;channelUuid=c0a15f91-7c1c-11eb-8904-42010aa8d42b\" defer></script>"
    },
    {
      "ID": "custom_engrain_sitemap_id",
      "type": "STRING",
      "value": "l27vqkxqvox"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/l27vqkxqvox"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "814-485-9174"
    },
    {
      "ID": "custom_seattle_income_limits_url",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImVzbVh5ZW00dHY2NXZIWVNtWERoZ1E9PSIsInZhbHVlIjoidGFlTHhTazk3K3lDSzJVOW0rWVdGQT09IiwibWFjIjoiMDRjZTliMTQ1MGNjYjBjMDZkMmE3NjU1NzcwNWViY2FkZmQ3ZWRmNjA4NWY2MjE4MTE3NmMyMTNmYWMxNDhlYiJ9"
    },
    {
      "ID": "custom_pillar_properties_guarantee",
      "type": "STRING",
      "value": "Who says there are no guarantees in life?     At Pillar Properties, we care and it shows. As a family-owned company with roots in the Puget Sound region spanning five generations, we do things our way. That means we are focused on delivering an ideal resident experience as measured by our own exacting standards.     Our team works diligently to ensure that the experience at our properties aligns with residents’ lifestyles, needs, and expectations. Resident satisfaction drives everything we do. We know that feeling supported is one of the most important hallmarks of home and that is why we offer our Quietly Awesome Guarantee.     We are so confident that you will love your new Pillar Properties apartment that we will waive the early termination penalties as defined in your lease if you are not satisfied and decide to leave within the first thirty days. It’s just that simple."
    },
    {
      "ID": "custom_seattle_income_qualified_blurb",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_pillar_properties_screening_criteria",
      "type": "STRING",
      "value": "https://multihubmedia.com/company/5767906449162415/019db50d-a878-72d8-8525-3b5177277f86.pdf"
    },
    {
      "ID": "custom_pillar_properties_guarantee_disclaimer",
      "type": "STRING",
      "value": "·  Guarantee applies to the first 30 days of occupancy only  ·  Notify the Property Manager in writing if you decide to move  ·  Any extra days will be charged if the apartment is not vacated after the initial 30 days"
    }
  ],
  "custom_qb_id": "4928",
  "custom_repli_id": "9241077743",
  "custom_google_gtm_id": "GTM-TVSNQF3X",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"https://webchat.omni.cafe/conversations/3bee234b-db22-4d05-a479-725b22138ac8/app.js?property=3bee234b-db22-4d05-a479-725b22138ac8&amp;propertyName=The+Meyden&amp;channelUuid=c0a15f91-7c1c-11eb-8904-42010aa8d42b\" defer></script>",
  "custom_engrain_sitemap_id": "l27vqkxqvox",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/l27vqkxqvox",
  "custom_ppc_tracking_phone_number": "814-485-9174",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImVzbVh5ZW00dHY2NXZIWVNtWERoZ1E9PSIsInZhbHVlIjoidGFlTHhTazk3K3lDSzJVOW0rWVdGQT09IiwibWFjIjoiMDRjZTliMTQ1MGNjYjBjMDZkMmE3NjU1NzcwNWViY2FkZmQ3ZWRmNjA4NWY2MjE4MTE3NmMyMTNmYWMxNDhlYiJ9",
  "custom_pillar_properties_guarantee": "Who says there are no guarantees in life?     At Pillar Properties, we care and it shows. As a family-owned company with roots in the Puget Sound region spanning five generations, we do things our way. That means we are focused on delivering an ideal resident experience as measured by our own exacting standards.     Our team works diligently to ensure that the experience at our properties aligns with residents’ lifestyles, needs, and expectations. Resident satisfaction drives everything we do. We know that feeling supported is one of the most important hallmarks of home and that is why we offer our Quietly Awesome Guarantee.     We are so confident that you will love your new Pillar Properties apartment that we will waive the early termination penalties as defined in your lease if you are not satisfied and decide to leave within the first thirty days. It’s just that simple.",
  "custom_pillar_properties_screening_criteria": "https://multihubmedia.com/company/5767906449162415/019db50d-a878-72d8-8525-3b5177277f86.pdf",
  "custom_pillar_properties_guarantee_disclaimer": "·  Guarantee applies to the first 30 days of occupancy only  ·  Notify the Property Manager in writing if you decide to move  ·  Any extra days will be charged if the apartment is not vacated after the initial 30 days"
};

export const generatedAt = '2026-09-29T17:44:03.216Z';
